export default __webpack_public_path__ + "content/media/30.aa08044f.jpg";